import {ContentfulLogoSuite} from '@github-ui/swp-core/components/contentful/ContentfulLogoSuite'
import {isPrimerLogoSuite} from '@github-ui/swp-core/schemas/contentful/contentTypes/primerComponentLogoSuite'
import {isPrimerTestimonial} from '@github-ui/swp-core/schemas/contentful/contentTypes/primerComponentTestimonial'
import {Box} from '@primer/react-brand'

import styles from './Highlight.module.css'
import {Testimonial} from './Testimonial'

export const Highlight = ({entry}: {entry: unknown}) => {
  if (isPrimerTestimonial(entry)) {
    return (
      <Box className={styles.styledTestimonial} marginBlockStart="spacious" marginBlockEnd="spacious">
        <Testimonial component={entry} />
      </Box>
    )
  }

  if (isPrimerLogoSuite(entry)) {
    return (
      <div className={styles.styledLogos}>
        <ContentfulLogoSuite component={entry} />
      </div>
    )
  }

  return null
}
